import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceSound} from "../sound/BruteForceSound";
import {BruteForceGameConfig} from "../BruteForceGameConfig";

export class BruteForceXNudgePresentation implements SimplePresentation {
    name: string = "XNudgePresentation";
    private _tl: gsap.core.Timeline;

    shouldRun(): boolean {
        return BruteForce.model.toNudge.includes(true);
    }

    start(controller: SimplePresentationRunnerController): void {
        const isXNPartOfWin: boolean[] = BruteForce.model.isXNPartOfWin;
        this._tl = gsap.timeline();
        this._tl.to(this, {duration: 0.2});
        this._tl.add(() => {
            controller.setSkipCallback(() => {
                BruteForceGameConfig.nudgePresentationFirstSkip = true;
                BruteForceSound.stopNudgeSparkSound();
                BruteForceSound.stopNudgeSound();
                this._tl.seek("endOfNudge", false);
            });
        }, 0);

        BruteForce.model.toNudge.forEach((value: boolean, reelId: number) => {
            if (value) {
                const xNudgeSym: BruteForceXNudgeSymbol = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelId].getStopSymbolAt(BruteForce.allreelsView.reelModels[reelId].reelView.nudgeReelPos),
                    nudgeTl: gsap.core.Timeline = gsap.timeline(),
                    nudgeReel: SimpleReelModel = BruteForce.allreelsView.reelModels[reelId],
                    totalSteps: number = nudgeReel.stepsToNudge;
                if (totalSteps > 0 && isXNPartOfWin[reelId]) {
                    nudgeTl.add(BruteForce.reelOverlayView.showNudgeReelHighlight(reelId));
                    nudgeTl.add(() => {
                        BruteForceSound.playNudgeSparkSound()
                    });
                }
                for (let i: number = 0; i < totalSteps; i++) {
                    nudgeTl.add(nudgeReel.nudge(!xNudgeSym.isNudgeDirectionDown, isXNPartOfWin[reelId]));
                    if (isXNPartOfWin[reelId]) {
                        let currentNudgeOverPos: number = nudgeReel.reelView.nudgeReelPos + (xNudgeSym.isNudgeDirectionDown ? (i + xNudgeSym.nudgeSymHeight - 1) : -(i + 1));
                        let currentStep: number = JSON.parse(JSON.stringify(totalSteps));
                        if (i === 0) {
                            nudgeTl.add(xNudgeSym.firstNudge(), "<");
                        }
                        if (i < currentStep - 1) {
                            nudgeTl.add(() => {
                                BruteForceSound.playNudgeSound(i);
                            }, "<");
                            nudgeTl.add(xNudgeSym.playSpineAnimation("landing2_feature", false).timeScale(1.2), "<");
                        } else if (i === currentStep - 1) {
                            nudgeTl.add(xNudgeSym.playSpineAnimation("hold_feature", false).timeScale(1.2), "<");
                            nudgeTl.add(() => {
                                BruteForceSound.stopNudgeSound();
                                BruteForceSound.stopNudgeSparkSound();
                                BruteForceSound.playTrack(BruteForceSound.NUDGE_FINAL_LAND)
                            }, "<");
                        }
                        nudgeTl.add(nudgeReel.reelView.nudgeSparks(xNudgeSym.isNudgeDirectionDown, reelId, currentNudgeOverPos), "<");
                        nudgeTl.add(xNudgeSym.multiplierIncreaseByNudge(i), "<");
                    }
                }
                nudgeTl.add(BruteForce.reelOverlayView.hideHighlight(reelId), ">");
                  nudgeTl.add(() => {
                     nudgeReel.hideVisualSymbol()
                  }, "<");
                if (!isXNPartOfWin[reelId]) {
                    nudgeTl.add(() => {
                        xNudgeSym.fixMultiplierAtbottom(BruteForce.model.gameData.xNudgeMultipliers[reelId]);
                        xNudgeSym.setMeter(BruteForce.model.gameData.xNudgeMultipliers[reelId]);
                    }, "<");
                } else {
                    nudgeTl.timeScale(1.5);
                }
                this._tl.add(nudgeTl);
            }
        });

        this._tl.addLabel("endOfNudge");
        this._tl.add(() => {
            controller.setSkipCallback(() => {
                BruteForceGameConfig.nudgePresentationSecondSkip = true;
                this._tl.seek("endOfAnimation", false);
            });
            if (!BruteForce.gameContainer.isTotalNudgeTextVisible) {
                BruteForce.gameContainer.showMultiplier("");
            } else {
                if (BruteForce.model.mode === BruteForceGameMode.FREESPIN_SUPER) {
                    BruteForce.gameContainer.showWinningStickyXNMultiOnScreen();
                }
            }
        }, "endOfNudge");

        BruteForce.model.toNudge.forEach((value: boolean, reelId: number) => {
            if (value) {
                const xnSym: BruteForceXNudgeSymbol = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelId].getStopSymbolAt(BruteForce.allreelsView.reelModels[reelId].reelView.nudgeReelPos),
                    animTl: gsap.core.Timeline = gsap.timeline();


                //nudgeReel.stepsToNudge = 0;

                if (isXNPartOfWin[reelId]) {
                    animTl.add(xnSym.playSpineAnimation("intro", false));
                    //   nudgeTl.to(this, {duration: 20000});
                    animTl.add(() => {
                        BruteForceSound.playNudgeWeapons(xnSym.typeOfNudge - 1);
                    }, 0);
                    animTl.add(xnSym.playSpineAnimation("loop", false));
                    animTl.add(xnSym.playTease(BruteForce.model.gameData.xNudgeMultipliers[reelId]), "<");
                    animTl.add(xnSym.meterAnimation(), "<");
                    animTl.add(xnSym.playSpineAnimation("outro", false));
                }
                if (isXNPartOfWin[reelId]) {
                    animTl.add(xnSym.animateToFinalMutliplierValue(BruteForce.model.gameData.xNudgeMultipliers[reelId]), "<");
                }
                animTl.add(xnSym.adjustMeterBackToSymbol(), "<");

                this._tl.add(animTl, "endOfNudge");

                //adding to nudge counter
                if ((isXNPartOfWin[reelId] && BruteForce.model.mode !== BruteForceGameMode.FREESPIN_SUPER) || BruteForce.model.mode === BruteForceGameMode.FREESPIN_SUPER) {
                    const additionTL: gsap.core.Timeline = gsap.timeline();
                    additionTL.add(BruteForce.gameContainer.getNudgeMultiplierFlying(xnSym.typeOfNudge, reelId, BruteForce.model.gameData.xNudgeMultipliers[reelId]));
                    additionTL.add(() => {
                        if (isXNPartOfWin[reelId]) {
                            BruteForce.gameContainer.changeMultiplier(BruteForce.model.gameData.xNudgeMultipliers[reelId], true);
                        }
                    }, ">");
                    this._tl.add(additionTL);
                }
            }
        });
        this._tl.addLabel("endOfAnimation");
        this._tl.add(() => {
            BruteForceSound.stopNudgeWeapons();
            BruteForceSound.stopMeterPoints();
            BruteForceSound.stopNudgePointHighlight();
            BruteForceSound.stopPointsToCounter();
            BruteForceSound.stopNudgeCounterBlast();
        });
        this._tl.to(this, {duration: 0.01}, ">");
        this._tl.add(() => {
            BruteForceGameConfig.nudgePresentationFirstSkip = false;
            BruteForceGameConfig.nudgePresentationSecondSkip = false;
            BruteForceSound.meterEffectsReset();
            BruteForce.reelOverlayView.emptyReelView();
            BruteForce.allreelsView.reelModels.forEach((reelViewModel: SimpleReelModel, reelId: number) => {
                reelViewModel.reelView.isReelContainingFullNudge = BruteForce.model.gameData.xNudgeSticky[reelId];
                reelViewModel.stepsToNudge = 0;
            });
            controller.setSkipCallback();
            controller.finish();
        });
    }
}